import { Flex, Icon, Text } from '@chakra-ui/react'
import { ConditionalValue } from '@chakra-ui/react'
import { MicOff, Pause, TriangleAlert } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import IconMangoLogo from '~/assets/svgs/icon-mango-logo.svg?react'
import { TranslationKeys } from '~/locales/i18next'
import { Size } from '~/types/ThemeTypes'

import {
  CallSoundIndicatorVariants,
  useCallSoundIndicatorStyles,
} from './componentStyles/CallSoundIndicator.style'

const VariantMap: Record<
  CallSoundIndicatorVariants,
  { icon: React.ElementType; textKey?: TranslationKeys }
> = {
  [CallSoundIndicatorVariants.Active]: {
    icon: IconMangoLogo,
  },
  [CallSoundIndicatorVariants.Hold]: {
    icon: Pause,
    textKey: 'callSoundIndicator.onHold',
  },
  [CallSoundIndicatorVariants.Mute]: {
    icon: MicOff,
    textKey: 'callSoundIndicator.muted',
  },
  [CallSoundIndicatorVariants.Reconnecting]: {
    icon: TriangleAlert,
    textKey: 'callSoundIndicator.reconnecting',
  },
}

interface CallSoundIndicatorProps {
  variant: CallSoundIndicatorVariants
  size: ConditionalValue<Size.sm | Size.md | Size.lg>
}
export const CallSoundIndicator = ({
  variant,
  size,
}: CallSoundIndicatorProps) => {
  const { t } = useTranslation()
  const styles = useCallSoundIndicatorStyles({ variant, size })
  const { icon, textKey } = VariantMap[variant]
  const text = textKey ? t(textKey) : ''
  return (
    <Flex
      css={{
        display: 'grid',
        gridTemplateAreas: '"overlay"',
        placeItems: 'center',
        ...styles.container,
      }}
    >
      <Flex css={{ gridArea: 'overlay', zIndex: 0, ...styles.pulse }} />
      <Flex
        css={{
          gridArea: 'overlay',
          zIndex: 1,
          ...styles.core,
          flexDirection: 'column',
        }}
      >
        <Icon as={icon} css={styles.icon} />
        <Text css={styles.text}>{text}</Text>
      </Flex>
    </Flex>
  )
}
